import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useHistory } from 'react-router';
import { useTheme } from '@material-ui/core';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';

import FacetFacNegative from 'Icons/Brand/FacetFacNegative';
import { changePasswordPath } from 'Consts/Strings';
import OnboardingHeader from '../../Components/Header';
import Actions from '../../Components/Actions';


const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(6),
    overflow: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: theme.dimensions.xl,
  },
});

const OnboardingTokenExpired = ({
  className,
  classes,
}) => {
  const theme = useTheme();

  const history = useHistory();
  const goToResetPassword = () => history.push(changePasswordPath);

  useScrollTopOnMount();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classes.content}>
        <FacetFacNegative
          style={{
            width: 55,
            height: 60,
            marginBottom: theme.spacing(4),
          }}
        />

        <OnboardingHeader
          title={'Your session has expired.'}
          subTitle={'Please reset your password below.'}
          centered
        />

        <Actions>
          <RoundedButton
            onClick={goToResetPassword}
            variant={'contained'}
            test={'token-expired-reset-password-button'}
            color={'primary'}
            fullWidth
            disableElevation
            size={DS_SIZE_MAP.sm}
          >
            {'Reset Password'}
          </RoundedButton>
        </Actions>
      </div>
    </Box>
  );
};

OnboardingTokenExpired.defaultProps = {
  className: '',
};

OnboardingTokenExpired.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingTokenExpired);
